import { Card, CardContent, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from "@mui/material";
import { Component } from "react";
import i18n from "../../i18n";
import { fCurrency } from "../../utils/formatNumber";
import config from "../../config";


class PaymentTypePaymentMethodTable extends Component {

	constructor(props) {
		super(props);

		this.state = {
			paymentTypeDetails: this.props?.paymentTypeDetails ?? []
		}

	}

	componentDidUpdate(prevProps) {
		if (this.props.paymentTypeDetails !== prevProps.paymentTypeDetails) {
			this.setState({
				paymentTypeDetails: this.props?.paymentTypeDetails ?? []
			});
		}
	}

	render() {

		console.log(this.state.paymentTypeDetails);

		return (
			<Card>
				<CardContent>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>{i18n.t('payment_type')}</TableCell>
								<TableCell>{i18n.t('payment_method')}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{i18n.t('total_transactions')}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{i18n.t('amount')}</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{(this.state.paymentTypeDetails).map((paymentTypeDetail, index) => (
								<TableRow key={index}>
									<TableCell>{i18n.t(paymentTypeDetail.paymentType)}</TableCell>
									<TableCell>{paymentTypeDetail?.paymentMethod ? i18n.t(paymentTypeDetail?.paymentMethod) : ''}</TableCell>
									<TableCell sx={{textAlign: 'right'}}>{paymentTypeDetail.count}</TableCell>
									<TableCell sx={{textAlign: 'right'}}>{fCurrency(paymentTypeDetail.total, i18n.t('OPTIONS.i18n_number_format'), config.currencyCode, false)}</TableCell>
								</TableRow>
							))}
						</TableBody>
						<TableHead>
							<TableRow>
								<TableCell colSpan={2}>{`${i18n.t('cash')} + ${i18n.t('card')}`}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{this.state.paymentTypeDetails.filter((paymentTypeDetail) => (paymentTypeDetail.paymentType === config.paymentTypes.CASH.key || paymentTypeDetail.paymentType === config.paymentTypes.CARD.key)).reduce((acc, curr) => acc + curr.count, 0)}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{fCurrency(this.state.paymentTypeDetails.filter((paymentTypeDetail) => (paymentTypeDetail.paymentType === config.paymentTypes.CASH.key || paymentTypeDetail.paymentType === config.paymentTypes.CARD.key)).reduce((acc, curr) => acc + curr.total, 0), i18n.t('OPTIONS.i18n_number_format'), config.currencyCode, false)}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell colSpan={2}>{`${i18n.t('payrexx')} + ${i18n.t('twint')}`}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{this.state.paymentTypeDetails.filter((paymentTypeDetail) => (paymentTypeDetail.paymentType === config.paymentTypes.TWINT.key || paymentTypeDetail.paymentType === config.paymentTypes.PAYREXX.key)).reduce((acc, curr) => acc + curr.count, 0)}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{fCurrency(this.state.paymentTypeDetails.filter((paymentTypeDetail) => (paymentTypeDetail.paymentType === config.paymentTypes.TWINT.key || paymentTypeDetail.paymentType === config.paymentTypes.PAYREXX.key)).reduce((acc, curr) => acc + curr.total, 0), i18n.t('OPTIONS.i18n_number_format'), config.currencyCode, false)}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>{i18n.t('online')}</TableCell>
								<TableCell>{`${i18n.t('payrexx')} + ${i18n.t('twint')}`}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{this.state.paymentTypeDetails.filter((paymentTypeDetail) => paymentTypeDetail.paymentType === config.paymentTypes.ONLINE.key).reduce((acc, curr) => acc + curr.count, 0)}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{fCurrency(this.state.paymentTypeDetails.filter((paymentTypeDetail) => paymentTypeDetail.paymentType === config.paymentTypes.ONLINE.key).reduce((acc, curr) => acc + curr.total, 0), i18n.t('OPTIONS.i18n_number_format'), config.currencyCode, false)}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell colSpan={2}>{i18n.t('total')}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{this.state.paymentTypeDetails.reduce((acc, curr) => acc + curr.count, 0)}</TableCell>
								<TableCell sx={{textAlign: 'right'}}>{fCurrency(this.state.paymentTypeDetails.reduce((acc, curr) => acc + curr.total, 0), i18n.t('OPTIONS.i18n_number_format'), config.currencyCode, false)}</TableCell>
							</TableRow>
						</TableHead>
					</Table>
				</CardContent>
			</Card>
		);
	}
}

export default PaymentTypePaymentMethodTable;
